'use strict'
import { axios, getErrorMessage } from '../helpers/axioshelper'

export default {
  getFolderStructure() {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/imagebank')
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  uploadImage(fData) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/imagebank/images', fData)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  addFolder(folder) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/imagebank/folders', folder)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  }
}
